import { createSlice } from '@reduxjs/toolkit';
import { saveToken, getToken, removeToken } from '../helpers/Token';
import { signIn, launchApp } from "../actions/sessionActions";

export interface AdminInterface {
  avatar_url?: string | null;
  email?: string;
  username?: string;
  role?: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  token: string | null;
  collapsed: boolean;
  admin: AdminInterface
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  token: getToken(),
  collapsed: true,
  admin: {}
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    signOut(state) {
      state.error = null;
      state.token = null;

      removeToken();
    },
    setError(state, action) {
      state.error = action.payload;
    },
    toggleSidebar(state, action) {
      state.collapsed = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(launchApp.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(launchApp.fulfilled, (state, action) => {
        state.admin = action.payload;
        state.status = 'succeeded';
      })
      .addCase(launchApp.rejected, (state, action) => {
        removeToken();
        state.token = null;
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      .addCase(signIn.fulfilled, (state, action) => {
        const { token } = action.payload;

        if (token) {
          state.error = null;
          state.token = token;
          state.status = 'idle';
          state.admin = action.payload;

          saveToken(token);
        } else {
          state.error = `UNKNOWN RESPONSE ${JSON.stringify(action.payload)}`
        }
      })
      .addCase(signIn.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;

        state.status = 'failed';
        state.error = error || action.error.message || 'Unknown Error';
      })
  }
});

export const {
  signOut,
  setError,
  toggleSidebar
} = sessionSlice.actions;
export default sessionSlice.reducer;
